import type { ReactNode } from 'react';
import { CircleNotchIcon, WarningCircleIcon } from '@phosphor-icons/react';
import { AlertContainer, AlertDescription } from 'src/components/ui/alert';

/**
 * The spinner-then-error preamble every workflows list page opens with. Renders
 * `children` only once the query has settled successfully, so callers stop
 * restating the same two blocks.
 */
export function QueryStateGate({
  isLoading,
  error,
  errorMessage,
  children,
}: {
  isLoading: boolean;
  error: unknown;
  /** Shown when the error carries no message of its own. */
  errorMessage: string;
  children: ReactNode;
}) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <CircleNotchIcon className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-12">
        <AlertContainer variant="destructive">
          <WarningCircleIcon className="h-4 w-4" />
          <AlertDescription>
            {error instanceof Error ? error.message : errorMessage}
          </AlertDescription>
        </AlertContainer>
      </div>
    );
  }

  return <>{children}</>;
}
